import type { SVGProps } from "react";
export interface BabyMilkIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function BabyMilkIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: BabyMilkIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M16.644 8.956a1.125 1.125 0 0 1 1.414.523l.047.105.244.66a14.6 14.6 0 0 1 .73 3.608q.01.073.011.149l-.001.008a16.4 16.4 0 0 1-.272 4.197 18 18 0 0 1-.575 2.218l-.009.025-.216.606a3.11 3.11 0 0 1-2.93 2.07H8.913a3.11 3.11 0 0 1-2.84-1.841l-.09-.229-.217-.606-.009-.025c-1.143-3.473-1.261-7.331.138-10.84a1.125 1.125 0 0 1 2.09.832c-1.17 2.934-1.1 6.238-.092 9.3l.21.585.055.124a.86.86 0 0 0 .755.45h6.174a.86.86 0 0 0 .81-.574l.208-.585q.098-.3.185-.605l-.77.014a1.125 1.125 0 0 1-.039-2.25l1.277-.023q.112-.863.117-1.726H15.5a1.125 1.125 0 0 1 0-2.25h1.197a12 12 0 0 0-.476-1.905l-.205-.555-.038-.108a1.125 1.125 0 0 1 .666-1.352"
      />
      <path
        fill={color}
        d="M12.625 3.75a.626.626 0 0 0-1.25 0c0 .194.037.4.103.733.059.297.146.72.146 1.172a2.99 2.99 0 0 1-1.82 2.752l-.224.085a2.5 2.5 0 0 0-.749.383h6.338a2.2 2.2 0 0 0-.402-.247l-.346-.136a2.99 2.99 0 0 1-2.046-2.837c0-.452.087-.875.146-1.172.066-.333.104-.54.104-.733m2.25 0c0 .452-.088.874-.146 1.17-.066.334-.104.54-.104.735 0 .319.204.602.506.703l.305.111c.692.275 1.266.666 1.72 1.198.51.6.808 1.31.996 2.06a1.126 1.126 0 0 1-1.091 1.397H6.94a1.124 1.124 0 0 1-1.091-1.397c.187-.75.484-1.46.994-2.06.519-.609 1.196-1.033 2.025-1.31l.108-.045a.74.74 0 0 0 .398-.657c0-.194-.036-.401-.102-.734-.059-.297-.146-.72-.147-1.17a2.875 2.875 0 1 1 5.75 0Z"
      />
    </svg>
  );
}
